import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";

const OrganisationSwitch = ({
  isModalOpen,
  setIsSwitchOn,
  setIsModalOpen,
  setShowSsoDropdown,
  isTurningOn
}: any) => {
  const style = {
    position: "absolute",
    top: "50%", 
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 1,
    p: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: 250,
    textAlign: "center", 
  };

  const handleTurnOn = () => {
    setIsSwitchOn(true);
    setShowSsoDropdown(true);
    setIsModalOpen(false);
    
  };

  const handleConfirm = () => {
    setIsSwitchOn(isTurningOn);
    setShowSsoDropdown(isTurningOn); // only show dropdown if turning ON
    setIsModalOpen(false);
  };

  return (
    <div>
      <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="body2"
              sx={{ fontWeight: "1000", fontSize: "20px" }}
            >
             {isTurningOn
              ? "Are you sure you want to turn on the SSO?"
              : "Are you sure you want to turn off the SSO?"}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                p: 2,
                fontSize: "14px",
                fontWeight: 500,
                color: "#00000080!important",
                mb: 2,
              }}
            >
              {isTurningOn
              ? "If you turn on the SSO, all existing users will have to login only through SSO. Password-based login will be disabled."
              : "If you turn off the SSO, users will be allowed to login using passwords again."}
            </Typography>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 20,
                justifyContent: "center",
              }}
            >
              <Button
                variant="outlined"
                sx={{ width: 140 }}
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </Button>
              {/* <Button
                variant="contained"
                sx={{ width: 140 }}
                onClick={handleTurnOn}
              >
                Turn On
              </Button> */}
              <Button
              variant="contained"
              sx={{
                width: 140,
                backgroundColor: isTurningOn ? undefined : "#FF4D4F", // red if turning off
                "&:hover": {
                  backgroundColor: isTurningOn ? undefined : "#e04344",
                },
              }}
              onClick={handleConfirm}
            >
              {isTurningOn ? "Turn On" : "Turn Off"}
            </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

export default OrganisationSwitch;
